define('views/pages/AccountPageView',['underscore', 'backbone', 'jquery', 'router', 'app', 'PageView', 'hooks',
    'template!account',
    'TagCommander',
    'views/blocks/AccountNavigationView',
    'views/pages/account/AccountProfileView',
    'views/pages/account/AccountOrdersView',
    'views/pages/account/AccountFavoritesView',
    'views/pages/account/AccountPaymentView',
    'views/pages/account/AccountDashboardView',
    'views/pages/account/AccountSponsorshipView'
], function (_, Backbone, $, router, app, PageView, hooks,
             accountTemplate,
             TagCommander,
             AccountNavigationView,
             AccountProfileView,
             AccountOrdersView,
             AccountFavoritesView,
             AccountPaymentView,
             AccountDashboardView,
             AccountSponsorshipView)
{

    var account_pages_rewrite = ['LOYALTY', 'PROFILE', 'ORDERS', 'FAVORITES', 'PAYMENT', 'SPONSORSHIP'];
    var AccountPageView = PageView.extend({
        pageName: 'Account',
        className: 'page Account',
        events: {},
        hideMobileCart: true,
        initialize: function (options)
        {
            var view = this,
                customer = app.getCustomer();
            view.pageOptions = _.defaults(options,{});

            // PageView constructor heritage
            PageView.prototype.initialize.apply(view, arguments);
            //
            //
            view.listenTo(customer, 'logout', view.logout);
            view.listenTo(customer,'change:firstname change:lastname',view.onChangeCustomerName);
            //
            if (options.el) {
                // classic page loading initialize
                view.account_page = view.$('.account-page').data('account_page');
                view.render();
            } else {
                // microtemplating initialize
                view.account_page = view.getAccountPageId(options.link_rewrite);
                view.render(true);
            }
        },
        startPageTagCommander:function() {
            TagCommander.LoadPage(this.pageName,{account_page:this.account_page});
        },
        initialRender:function(){
            var accountPageView = this.accountPageView;
            if(accountPageView){
                accountPageView.afterInitialize();
            }
        },
        // converti un rewrite en id pour les sous-pages mon compte
        getAccountPageId: function (fromRewrite)
        {
            var account_page = 'dashboard', // default
                config = app.getConfigurations();
            _(account_pages_rewrite).each(function (rewrite)
            {
                var c = config.getValue('_ACCOUNT_' + rewrite + '_REWRITE_');
                if (c == fromRewrite) {
                    account_page = rewrite.toLowerCase();
                }
            });
            return account_page;
        },
        getPageView: function (fromId)
        {

            // Account Page Factory
            //
            // default view is Dashboard
            var accountSubPageView = AccountDashboardView,
                // constructor by Id
                pageConstructors = {
                    profile:AccountProfileView,
                    orders:AccountOrdersView,
                    favorites:AccountFavoritesView,
                    payment:AccountPaymentView
                };

            if (app.c('_ENABLE_SPONSORSHIP_')) {
                pageConstructors.sponsorship = AccountSponsorshipView;
            }
            if(pageConstructors[fromId]){
                accountSubPageView = pageConstructors[fromId];
            }else if(fromId === 'loyalty'){
                // Hook de la page Loyalty
                hooks.execHook('LoyaltyProfileView',null,function(View){
                    // only one sub view is available
                    accountSubPageView = View;
                });
                //
            }
            return accountSubPageView;
        },
        microtemplate: function (options)
        {
            var view = this,
                account_page = view.getAccountPageId(options.link_rewrite);
            view.pageOptions = _.defaults(options,{});;
            app.trigger('changeAccountPage', account_page);
            //
            view.account_page = account_page;
            if(view.accountPageView){
                view.detachView(view.accountPageView);
                //view.startPageTagCommander();
            }
            var el = $('<div class="account-page"><div class="inline-loader"><span class="loader"></span></div></div>').get(0);
            view.$('.account-sidebar').after(el);
            view.initializeAccountPageView(account_page, el);
            view.updateSidebar(account_page);
            //
        },
        render: function (useMicrotemplating)
        {
            var view = this,
                account_page = view.account_page;
            //
            if (useMicrotemplating === true) {
                this.$el.html(accountTemplate());
            }

            //  customer = app.getCustomer();
            //  alert(customer.get('firstname'));
            // Navigation
            view.attachView(
                new AccountNavigationView({
                    el: view.$('.account-sidebar').get(0),
                    account_page: account_page,
                    customer: app.getCustomer(),
                })
            );
            //
            view.initializeAccountPageView(account_page, view.$('.account-page').get(0));

        },
        onChangeCustomerName:function(customer){
            this.$('.customer-fullname').text(customer.getFullname());
        },
        updateSidebar: function(page){
            var sidebar = this.$('.account-sidebar'),
                sidebarItems =  sidebar.find('li a'),
                activeItem = sidebarItems.filter('[data-name="' + page + '"]');
            sidebarItems.removeClass('active');
            activeItem.addClass('active');
            if (app.isMobile()){
                var scrollVal = activeItem.offset().left + sidebar.scrollLeft() - 20;
                sidebar.scrollLeft(scrollVal);
            }
        },
        initializeAccountPageView: function (account_page, el)
        {
            // Account Page sub view
            var view = this, accountPageViewClass = view.getPageView(account_page),
                accountPageView = new accountPageViewClass({el: el});
            view.accountPageView = accountPageView;
            view.attachView(accountPageView);
            accountPageView.afterInitialize();
        },
        logout: function ()
        {
            // go home !
            app.go('home');
        }
    });

    return AccountPageView;

});
